export type MoneyLike = {
  units?: string | number | null
  nanos?: string | number | null
}

/**
 * Converts a protobuf-style Money object to a decimal number.
 *
 * Note: nanos are 1e-9 of a currency unit (1_000_000_000 nanos = 1 unit).
 */
export const getMoneyValue = (money?: MoneyLike | null): number => {
  const units = Number(money?.units ?? 0)
  const nanos = Number(money?.nanos ?? 0)
  const safeUnits = Number.isFinite(units) ? units : 0
  const safeNanos = Number.isFinite(nanos) ? nanos : 0

  return safeUnits + safeNanos / 1_000_000_000
}
